

import { INTENT_TYPES, APPLICATION_TYPES, TEST_CREATION_MODES } from './constant';


export const BASE_STEPS = [
  { id: 1, label: 'Select Intent',   key: 'intent_selection' },
  { id: 2, label: 'Create Workspace', key: 'workspace_setup' },
  { id: 3, label: 'Setup Project',   key: 'project_setup' },
];


export const MANUAL_TO_AUTOMATION_STEPS = [
  ...BASE_STEPS,
  { id: 4, label: 'Import Tests',       key: 'test_source' },
  { id: 5, label: 'Test Creation Mode', key: 'test_creation_mode' },
  { id: 6, label: 'Review & Edit',      key: 'preview' },
  { id: 7, label: 'Generate Scripts',   key: 'generate' },
  { id: 8, label: 'Execute Test',       key: 'run' },
  { id: 9, label: 'Summary',            key: 'complete' },
];


export const MIGRATE_SCRIPTS_STEPS = [
  ...BASE_STEPS,
  { id: 4, label: 'Import Scripts',       key: 'test_source' },
  { id: 5, label: 'Conversion Settings',  key: 'conversion_settings' },
  { id: 6, label: 'Convert Progress',     key: 'convert' },
  { id: 7, label: 'Execute Test',         key: 'run' },
  { id: 8, label: 'Summary',             key: 'complete' },
];


export const JIRA_REQUIREMENTS_STEPS = [
  ...BASE_STEPS,
  { id: 4, label: 'Import Tests',       key: 'test_source' },
  { id: 5, label: 'Test Creation Mode', key: 'test_creation_mode' },
  { id: 6, label: 'Generate Tests',     key: 'generate' },
  { id: 7, label: 'Execute Test',       key: 'run' },
  { id: 8, label: 'Summary',            key: 'complete' },
];


export const SAMPLE_PROJECT_STEPS = [
  { id: 1, label: 'Select Intent',   key: 'intent_selection' },
  { id: 2, label: 'Create Workspace', key: 'workspace_setup' },
  { id: 3, label: 'Summary',         key: 'complete' },
];


export const IOT_HARDWARE_STEPS = [
  ...BASE_STEPS,
  { id: 4,  label: 'Import Tests',   key: 'test_source' },
  { id: 5,  label: 'Interaction Mode', key: 'interaction_mode' },
  { id: 6,  label: 'Lab Agent',       key: 'lab_agent_setup' },
  { id: 7,  label: 'Device',          key: 'device_setup' },
  { id: 8,  label: 'Setup',           key: 'setup' },
  { id: 9,  label: 'Create Test',     key: 'create_test' },
  // { id: 10, label: 'Validation',      key: 'validation' },
  // { id: 11, label: 'Generate',        key: 'generate' },
  { id: 10, label: 'Run Test',        key: 'run' },
  { id: 11, label: 'Summary',         key: 'complete' },

   //these are the actaul steps commenting them to disable some previous steps
  //   { id: 10, label: 'Validation',      key: 'validation' },
  // { id: 11, label: 'Generate',        key: 'generate' },
  // { id: 12, label: 'Run Test',        key: 'run' },
  // { id: 13, label: 'Summary',         key: 'complete' },
];


export const getStepFlowForIntent = (intent) => {
  switch (intent) {
    case INTENT_TYPES.MANUAL_TO_AUTOMATION: return MANUAL_TO_AUTOMATION_STEPS;
    case INTENT_TYPES.MIGRATE_SCRIPTS:      return MIGRATE_SCRIPTS_STEPS;
    case INTENT_TYPES.JIRA_REQUIREMENTS:    return JIRA_REQUIREMENTS_STEPS;
    case INTENT_TYPES.SAMPLE_PROJECT:       return SAMPLE_PROJECT_STEPS;
    default:
      console.warn(`[stepFlows] Unknown intent "${intent}" — returning BASE_STEPS`);
      return BASE_STEPS;
  }
};


export const getStepFlowByMode = (baseFlow, testCreationMode) => {
  if (!testCreationMode) return baseFlow;

  // Steps 1–5 are always identical regardless of mode
  const commonSteps = baseFlow.slice(0, 5);

  switch (testCreationMode) {
    case TEST_CREATION_MODES.AI:
      return [
        ...commonSteps,
        { id: 6, label: 'AI Preview',      key: 'ai_preview' },
        { id: 7, label: 'Generate Scripts', key: 'generate' },
        { id: 8, label: 'Execute Test',    key: 'run' },
        { id: 9, label: 'Summary',         key: 'complete' },
      ];

    case TEST_CREATION_MODES.RECORDER:
      return [
        ...commonSteps,
        { id: 6,  label: 'Setup Tools',      key: 'setup_tools' },
        { id: 7,  label: 'Recording URL',    key: 'recording_url' },
        { id: 8,  label: 'Review Recording', key: 'review_recording' },
        { id: 9,  label: 'Execute Test',     key: 'run' },
        { id: 10, label: 'Summary',          key: 'complete' },
      ];

    case TEST_CREATION_MODES.UI_DISCOVERY:
      return [
        ...commonSteps,
        { id: 6,  label: 'AI Preview',       key: 'ai_preview' },
        { id: 7,  label: 'Setup Tools',      key: 'setup_tools' },
        { id: 8,  label: 'Discovery Setup',  key: 'discovery_setup' },
        { id: 9,  label: 'Discovery Crawl',  key: 'discovery_crawl' },
        { id: 10, label: 'Compile & Generate', key: 'review_discovery' },
        { id: 11, label: 'Execute Test',     key: 'run' },
        { id: 12, label: 'Summary',          key: 'complete' },
      ];

    default:
      console.warn(`[stepFlows] Unknown testCreationMode "${testCreationMode}" — returning base flow`);
      return baseFlow;
  }
};


export const getStepFlowForAppType = (intent, applicationType) => {
  if (applicationType === APPLICATION_TYPES.IOT_HARDWARE) {
    return IOT_HARDWARE_STEPS;
  }
  return getStepFlowForIntent(intent);
};

export const getCurrentStepFlow = (intent, testCreationMode) => {
  const baseFlow = getStepFlowForIntent(intent);
  const modeFlow = getStepFlowByMode(baseFlow, testCreationMode);
  return modeFlow;
};

/**
 * Step numbers for UI Discovery paths.
 * - `ui` / UI_DISCOVERY: AI Preview + Setup Tools inserted before Discovery Setup (steps 6–12)
 * - `discovery`: legacy entry (e.g. from AI Preview warning) without AI Preview / Setup Tools
 */
export const getUIDiscoveryStepNumbers = (mode) => {
  if (mode === 'ui' || mode === TEST_CREATION_MODES.UI_DISCOVERY) {
    return {
      aiPreview: 6,
      setupTools: 7,
      setup: 8,
      crawl: 9,
      review: 10,
      run: 11,
      summary: 12,
      modeQuery: 'ui',
    };
  }

  return {
    aiPreview: null,
    setupTools: null,
    setup: 6,
    crawl: 7,
    review: 10,
    run: 8,
    summary: 9,
    modeQuery: 'discovery',
  };
};

export const resolveStepFlow = (intent, applicationType, testCreationMode) => {
  if (applicationType === APPLICATION_TYPES.IOT_HARDWARE) {
    return IOT_HARDWARE_STEPS;
  }
  const baseFlow = getStepFlowForIntent(intent);
  return getStepFlowByMode(baseFlow, testCreationMode);
};

export const getStepDefinitionsByIds = (stepIds, testCreationMode = null) => {
  // If mode provided, we need to get the mode-specific flow to get correct labels
  if (testCreationMode) {
    // Build a map of step ID → definition for quick lookup
    const modeFlow = getStepFlowByMode(BASE_STEPS, testCreationMode);
    const modeFlowMap = {};
    modeFlow.forEach(step => {
      modeFlowMap[step.id] = step;
    });
    
    const baseStepsMap = {};
  BASE_STEPS.forEach(step => { baseStepsMap[step.id] = step; });
    
    return stepIds.map(id => {
      if (id <= 5) {
        return baseStepsMap[id] || { id, label: `Step ${id}`, key: `step_${id}` };
      } else {
        return modeFlowMap[id] || { id, label: `Step ${id}`, key: `step_${id}` };
      }
    });
  }
  
  // Fallback if no mode provided (use static definitions)
  const fallbackMap = {};
  [...MANUAL_TO_AUTOMATION_STEPS, ...IOT_HARDWARE_STEPS].forEach(step => {
    fallbackMap[step.id] = step;
  });
  return stepIds.map(id => fallbackMap[id] || { id, label: `Step ${id}`, key: `step_${id}` });
};